const ECMR_PROVIDER = 'transfollow';

export class EcmrAccessInfo {
  /**
   * The access details agreed with third party eCMR providers, as one base64 encoded JSON parameter.
   * Every builder of the driver assign link has to send it, or scanning the same transport gives an
   * app the access info from one screen and nothing from another.
   */
  static encode(accessCode: string, submitter?: string): string {
    if (!accessCode) {
      return undefined;
    }

    const accessInfo = {
      ecmrProvider: ECMR_PROVIDER,
      shipmentAccessCode: accessCode,
      ...(submitter ? { tenant: submitter } : {})
    };

    // btoa only accepts latin1, and a submitter name can hold anything
    const utf8 = new TextEncoder().encode(JSON.stringify(accessInfo));
    return btoa(String.fromCharCode(...utf8));
  }
}
